// ─────────────────────────────────────────────────────────────────
// Glass-i — Glass Type Routing API client (Stage WO-2A).
// Thin axios wrappers around /api/erp/masters/glass-type-routing/*.
//   matrix   → { stages, glassTypes, selections } for the config page
//   bulkSave → persist the matrix ({ selections: { type: [groups] } })
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/masters/glass-type-routing';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : (resp ? resp.data : null);
}

export const glassTypeRoutingApi = {
  matrix:   ()          => client.get(`${BASE}/matrix`).then(unwrap),
  bulkSave: (selections) => client.post(`${BASE}/bulk-save`, { selections }).then(unwrap)
};

export default glassTypeRoutingApi;
